import FileService from '../../../services/file-service';
import FormatService from '../../../services/format-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../../constants/system/file-extensions';
import {
  DEAL_STATUS_COMPLETED, DEAL_STATUS_DEAD_DEAL, DEAL_STATUS_DEAL_CLOSED, DEAL_STATUS_DRAFT,
  DEAL_STATUS_DUE_DILIGENCE, DEAL_STATUS_IDLE, DEAL_STATUS_IN_EXECUTION,
  DEAL_STATUS_INITIAL, DEAL_STATUS_REALIZED_INVESTMENTS,
} from '../../../constants/entity/deal-statuses';
import {
  ACTIVITY_STATUS_DEAD_DEAL, ACTIVITY_STATUS_DEAL_CLOSED, ACTIVITY_STATUS_DUE_DILIGENCE,
  ACTIVITY_STATUS_INITIAL, ACTIVITY_STATUS_REALIZED_INVESTMENTS,
} from '../../../constants/entity/activity-statuses';

const SettingsAccountValidator: Validator = (values: FormValues): ValidationErrors => {
  const SYSTEM_DEAL_STATUS_LIST: string[] = [
    DEAL_STATUS_DRAFT, DEAL_STATUS_INITIAL, DEAL_STATUS_DUE_DILIGENCE,
    DEAL_STATUS_DEAL_CLOSED, DEAL_STATUS_IN_EXECUTION, DEAL_STATUS_COMPLETED, DEAL_STATUS_IDLE,
    DEAL_STATUS_REALIZED_INVESTMENTS, DEAL_STATUS_DEAD_DEAL,
  ];

  const SYSTEM_ACTIVITY_STATUS_LIST: string[] = [
    ACTIVITY_STATUS_INITIAL, ACTIVITY_STATUS_DUE_DILIGENCE, ACTIVITY_STATUS_DEAL_CLOSED,
    ACTIVITY_STATUS_REALIZED_INVESTMENTS, ACTIVITY_STATUS_DEAD_DEAL,
  ];

  const errors: ValidationErrors = {};

  const requiredFields: string[] = [
    'name',
    'role',
    'accountSubscriptionPlan',
  ];

  if (values.account && Object.keys(values.account).length) {
    if (!errors.account) {
      errors.account = {};
    }

    requiredFields.forEach((field: string): void => {
      if (!values.account[field] || !values.account[field].toString().trim()) {
        errors.account[field] = 'Required';
      }
    });

    if (values.account.photo && !FileService.checkFileExtension(values.account.photo, FILE_EXTENSION_LIST_IMAGE)) {
      errors.account.photo = 'Incorrect file type';
    }

    if (values.account.yardiConnectorEmail && !FormatService.isValidEmail(values.account.yardiConnectorEmail)) {
      errors.account.yardiConnectorEmail = 'Invalid email address';
    }

    if (errors.account && !Object.keys(errors.account).length) {
      delete errors.account;
    }
  }

  if (values.accountDealStatuses && Object.keys(values.accountDealStatuses).length) {
    if (!errors.accountDealStatuses) {
      errors.accountDealStatuses = {};
    }

    Object.keys(values.accountDealStatuses).forEach((accountDealStatusIndex: string): void => {
      if (!errors.accountDealStatuses[accountDealStatusIndex]) {
        errors.accountDealStatuses[accountDealStatusIndex] = {};
      }

      const accountDealStatus: ValidationEntityInput = {
        ...values.accountDealStatuses[accountDealStatusIndex],
      };

      if (SYSTEM_DEAL_STATUS_LIST.includes(accountDealStatus.status)
        && (!accountDealStatus.title || !accountDealStatus.title.trim())) {
        errors.accountDealStatuses[accountDealStatusIndex].title = 'Required';
      }

      if (errors.accountDealStatuses[accountDealStatusIndex]
        && !Object.keys(errors.accountDealStatuses[accountDealStatusIndex]).length) {
        delete errors.accountDealStatuses[accountDealStatusIndex];
      }
    });

    if (errors.accountDealStatuses && !Object.keys(errors.accountDealStatuses).length) {
      delete errors.accountDealStatuses;
    }
  }

  if (values.accountActivityStatuses && Object.keys(values.accountActivityStatuses).length) {
    if (!errors.accountActivityStatuses) {
      errors.accountActivityStatuses = {};
    }

    Object.keys(values.accountActivityStatuses).forEach((accountActivityStatusIndex: string): void => {
      if (!errors.accountActivityStatuses[accountActivityStatusIndex]) {
        errors.accountActivityStatuses[accountActivityStatusIndex] = {};
      }

      const accountActivityStatus: ValidationEntityInput = {
        ...values.accountActivityStatuses[accountActivityStatusIndex],
      };

      if (SYSTEM_ACTIVITY_STATUS_LIST.includes(accountActivityStatus.status)
        && (!accountActivityStatus.title || !accountActivityStatus.title.trim())) {
        errors.accountActivityStatuses[accountActivityStatusIndex].title = 'Required';
      }

      if (errors.accountActivityStatuses[accountActivityStatusIndex]
        && !Object.keys(errors.accountActivityStatuses[accountActivityStatusIndex]).length) {
        delete errors.accountActivityStatuses[accountActivityStatusIndex];
      }
    });

    if (errors.accountActivityStatuses && !Object.keys(errors.accountActivityStatuses).length) {
      delete errors.accountActivityStatuses;
    }
  }

  if (errors.account && !Object.keys(errors.account).length) {
    delete errors.account;
  }

  return errors;
};

export default SettingsAccountValidator;
